<!-- ScanPack  move -->
<template>
    <div id="scanPackMove">
        <a-modal title="Move" :visible="visible" width="85%" @cancel="moveHandleCancel" :maskClosable=false :footer="null">
            <!-- colse -->
            <template>
                <a-button size="small" @click="moveHandleCancel">{{ $t('publicLang.Close') }}</a-button>
                <!-- save inv moveDetail  -->
                <a-button  class="mg5" size="small" type="primary" @click="saveMoveDetails"   v-if="headerStatus != '00' ? false : true"   :disabled="this.tableData.length > 0 ? false : true"  >{{ $t('publicLang.Save') }}</a-button>
                <!-- confirm  -->
                <a-popconfirm :title="$t('publicLang.Areconfirm')" @confirm="confirmMove" :okText="$t('publicLang.Yes')"
                              :cancelText="$t('publicLang.No')">
                    <a-button class="mg5" size="small" type="primary" :style= "tableData.size > 0 ? '':'margin-left: 5px;'"    v-if="headerStatus != '00' ? false : true"   :disabled="this.tableData.length > 0 ? false : true" >{{ $t('publicLang.Confirm') }}</a-button>
                </a-popconfirm>
                <!--添加库位输入框,如果有值则代替下方列表To Location的值 Liyy 2023-3-30-->
                <b style="margin-left: 5px;">{{$t('pubGicSet.Location')}}:</b>
                <a-auto-complete style="width: 200px;border: 0px solid;" @search="handleSearch" :placeholder="$t('publicLang.PleaseSelect')" size="small" v-model="topLocation">
                    <template slot="dataSource">
                        <a-select-option v-for="item in completeData" :key="item.locationCode"  :value="item.locationCode">{{item.locationName}}</a-select-option>
                    </template>
                </a-auto-complete>
            </template>



            <a-divider style="margin: 10px 0px"  />
            <vxe-table  v-cloak
                        border resizable size="mini" :data="tableData"
                        keep-source
                        :edit-config="{trigger: 'manual', mode: 'row', key: 'uid'}"
                        ref="refMoveDetailTab">

                <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                </template>
                <vxe-table-column field="sku" :title="$t('pubGicSet.SKU')" show-header-overflow="ellipsis"
                                  show-overflow="ellipsis"></vxe-table-column>
                <vxe-table-column field="palletId" :title="$t('batchReceive.PalletID')" show-header-overflow="ellipsis"
                                  show-overflow="ellipsis"></vxe-table-column>
                <vxe-table-column field="cartonId" :title="$t('batchReceive.CartonID')" show-header-overflow="ellipsis"
                                  show-overflow="ellipsis"></vxe-table-column>
                <vxe-table-column field="logicWhs" :title="$t('pubGicSet.LogicalWH')" show-header-overflow="ellipsis"
                                  show-overflow="ellipsis"></vxe-table-column>
                <vxe-table-column field="avBaseQty" :title="$t('pubGicSet.AvailableQty')"
                                  show-header-overflow="ellipsis" show-overflow="ellipsis"
                ></vxe-table-column>
                <vxe-table-column field="fromLocation" :title="$t('pubGicSet.FromLocation')"
                                  show-header-overflow="ellipsis" show-overflow="ellipsis"></vxe-table-column>
                <vxe-table-column field="moveQty" :title="$t('pubGicSet.MoveQty')" show-header-overflow="ellipsis"
                                  show-overflow="ellipsis">
                    <template v-slot="{ row }">
                        <a-input-number :placeholder="$t('publicLang.PleaseEnter')" :min="1" v-model="row.moveQty"
                                        size="small" style="width: 100%;"  :disabled="false" />
                    </template>
                </vxe-table-column>
                <vxe-table-column field="toLocation" :title="$t('pubGicSet.ToLocation')" show-header-overflow="ellipsis"
                                  show-overflow="ellipsis">
                    <template v-slot="{ row }">
                        <a-auto-complete style="width: 100%;" @search="handleSearch"
                                         :placeholder="$t('publicLang.PleaseSelect')" size="small" v-model="row.toLocation">
                            <template slot="dataSource">
                                <a-select-option v-for="item in completeData" :key="item.locationCode">{{item.locationName}}</a-select-option>
                            </template>
                        </a-auto-complete>
                    </template>
                </vxe-table-column>
                <vxe-table-column :title="$t('generic.operate')" width="150" show-header-overflow="ellipsis"
                                  show-overflow="ellipsis"  v-if="headerStatus != '00' ? false : true" >
                    <template v-slot="{ row }">
                        <img @click="deleteRows(row)" style="margin-left: 4px" class="sbxs"
                             src="../../../assets/img/ss-delete.png" width="22" height="22" >
                    </template>
                </vxe-table-column>
            </vxe-table>
        </a-modal>
        <move-search ref="MoveAdvan" :searTableUid="moveSearTableUid" :adjustParHeaderId="moveHeaderUid"
                     :waseCode="moveWarehouse" v-on:getAdjustData="getAdjustData" :ajtype="adjust"></move-search>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import cookie from '../../../api/cookie'
    import api from '../../../api/url'
    import moveSearch from './adjustAdvanSearch/moveSearch.vue'
    export default {
        components: {
            moveSearch
        },
        data() {
            return {
                ifCancel: true,
                ifSearch: true,
                visible: false,
                form: this.$form.createForm(this),
                tableData: [],
                movelogicSelectData: [],
                moveReasonSelectData: [],
                wareHouseSelect: [],
                moveHeaderUid: "",
                moveSearTableUid: "",
                adjust: 'invMoveDetail',
                completeData: [],
                moveWarehouse: '', // ware code select
                isCancelMoveEvent: true,
                wareHourseDis: false,
                isSaveClick: true,
                //                chang 事件
                remarksVal: '',
                moveLogicVal: '',
                reasonCode: '',
                movePatwaytype: '',
                editInvMoveHeader: {},
                type: '',
                editType: '',
                dataType: "",

                pageSizeOptions: ['10', '20', '30', '40', '100', '200', '500', '1000'],
                pagingTotal: 0, // 总数
                 pagingSize: Number.parseInt(sessionStorage.getItem('pageSize') || '30'), // 条数
                currentVal: 1, // 页数
                headerStatus:'',
                warehouseCode: '',
                topLocation:"",
            }
        },
        methods: {
            saveMoveDetails(){

                let Records = this.$refs.refMoveDetailTab.getRecordset();
                let invMoveDetailDtos = Records.updateRecords
                let  deleteArr = Records.removeRecords
                let  deleteUidArr = []
                for(let i in deleteArr){
                    deleteUidArr.push(deleteArr[i].uid);
                }

                let data = this.tableData
                for(let i in data){
                    if(deleteUidArr.indexOf(data[i].uid) > -1){  // 忽略删除
                        continue;
                    }
                    if (data[i].toLocation == null || data[i].toLocation == '') {
                        this.$customMessage.error("SKU#"+data[i].sku+" toLocation cannot be empty.");
                        return;
                    }
                    if(data[i].moveQty < 1){
                        this.$customMessage.error("MoveQty Can't be less than 1.")
                        return;
                    }
                    if (data[i].moveQty > data[i].avBaseQty) {
                        this.$customMessage.error("ToQty out of range.")
                        return;
                    }
                }


                for(let i in invMoveDetailDtos){
                    let moveQty = invMoveDetailDtos[i].moveQty
                    let avBaseQty =  invMoveDetailDtos[i].avBaseQty
                    let toLocation = invMoveDetailDtos[i].toLocation

                    // 检查库存数据
                    if(toLocation == null || toLocation == ''){
                        this.$customMessage.error("ToLocation cannot be empty.")
                        return;
                    }

                    // 检查 调整数量 是否大于 可用数量
                    if( moveQty > avBaseQty){
                        this.$customMessage.error("MoveQty out of range.")
                        return;
                    }
                }

                if(invMoveDetailDtos != undefined){
                    ajax.post(api.UPDATEINVMOVEDETAIL,invMoveDetailDtos).then(res=>{
                        if(res.code == 200){
                            this.show2(this.moveHeaderUid,false)
                            this.$message.success(res.msg);
                        }else{
                            this.$customMessage.warning(res.msg);
                        }
                    })
                }
            },
            onShowSizeChange(current, pageSize) {
                this.currentVal = current;
                this.pagingSize = pageSize;
                this.changePage();
            },
            //      表格分页
            tableChangePage(current) {
                this.currentVal = current;
                this.changePage();
            },

            moveWarehouseChange(val) {
                this.moveWarehouse = val
            },
            moveLogicChange(val) {
                this.moveLogicVal = val
            },
            moveReasonChange(val) {
                this.moveReasonVal = val
            },
            moveHandleCancel() {
                this.visible = false
                this.wareHourseDis = false
                this.tableData = []
                this.isCancelMoveEvent = true
                this.remarksVal = ''
                this.ifCancel = true
                this.ifSearch = true
                this.isSaveClick = true
                this.moveHeaderUid = ''
                this.form.resetFields();
                this.editInvMoveHeader = {}
                this.topLocation = ""
            },
            show2(uid,init){
                ajax.get(api.INVENTORYINVMOVEINFO, {uid: uid}).then(res => {
                    if(res.code == 200){
                        if(init){this.init();}
                        this.headerStatus = res.data.status
                        this.tableData = res.data.invMoveDetailDtos
                        this.moveHeaderUid  = res.data.uid
                        this.remarksVal = res.data.remarks
                        this.moveSearTableUid = res.data.gmcUid
                        this.reasonCode = res.data.reasonCode
                        this.warehouseCode = res.data.whsCode
                        this.visible = true;
                    }else{
                        this.$customMessage.error(res.msg);
                    }
                })

            } ,
            show(params) {
                if(params != null){
                    ajax.post(api.EDITINVRNTORYINVSAVE, params).then(res => {   // 保存 生成数据
                        if (res.code == 501) {
                            this.visible = false
                            this.$customMessage.error(res.msg);
                            return
                        }else if(res.code == 200){              // 生成move  数据成功
                            this.moveHeaderUid = res.data.uid;
                            this.show2(this.moveHeaderUid,false)
                        }
                    })
                }else{
                    this.init();
                    this.visible = true
                }
            },

            changePage() { // 切换页码
                let params = {};
                params.uid = this.moveHeaderUid;
                if (this.dataType == 'PUTAWAY') {
                    params.pageNum = this.currentVal
                    params.pageSize = this.pagingSize
                }

                ajax.get(api.INVENTORYINVMOVE, params).then(res => {
                    if (this.dataType == 'PUTAWAY') {
                        this.tableData = res.data.data
                        this.pagingTotal = res.data.pagingTotal;
                    } else {
                        this.tableData = res.data
                    }
                })
            },

            //            初始化获取 个个下拉data
            init() {
                this.headerStatus = ''
                this.moveHeaderUid = ''
                this.reasonCode=''
                this.remarksVal = ''
                this.warehouseCode = ''
                this.tableData = []
                this.form.resetFields();
                ajax.get(api.USERDROPDOWNWHS).then(res=>{
                    if(res.code == 200){
                        this.wareHouseSelect = res.data.warehouseList
                        this.warehouseCode = res.data.warehouseCode
                    }
                })

                ajax.get(api.MOVEREASONSELECT).then(res => {
                    this.moveReasonSelectData = res.data
                })
            },
            //            header save
            saveMoveHeader() {
                this.form.validateFields((err, val) => {
                    if (!err) {
                        let params = {
                            uid : this.moveHeaderUid,
                            remarks: this.remarksVal,
                            reasonCode: this.reasonCode
                        }
                        ajax.post(api.INVMOVEHEADER, params).then(res => {
                            if (res.code == 200) {
                                this.moveHeaderUid = res.data.headerUid
                                this.moveSearTableUid = res.data.gmcUid
                                this.headerStatus = res.data.status
                                this.$message.success(res.msg);
                            } else {
                                this.$customMessage.error(res.msg)
                            }

                        })
                    }
                })
            },
            //            move cancel
            moveCancel() {
                ajax.post(api.INVENTORYMOVECANCEL, {
                    uid: this.moveHeaderUid
                }).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg)
                        this.headerStatus ='10'
                    } else {
                        this.$customMessage.error(res.msg)
                    }
                })
            },
            addMoveTable() {
                this.$refs.MoveAdvan.show()
            },
            getAdjustData(val) {
                this.tableData = val
            },
            deleteRows(row) {
                this.$refs.refMoveDetailTab.remove(row)
                ajax.post(api.DELINVMOVEDETAIL, {
                    uid: row.uid,
                    headerUid: this.moveHeaderUid,
                }).then(res => {
                    if (res.code == 200) {

                        let Records = this.$refs.refMoveDetailTab.getRecordset();
                        let  deleteArr = Records.removeRecords
                        if(deleteArr.length == this.tableData.length){
                            this.tableData = []
                            this.$refs.refMoveDetailTab.remove()
                        }
                        this.$message.success(res.msg)
                    } else {
                        this.$customMessage.error(res.msg)
                    }
                })
            },
            handleSearch(value) {
                if (value.length < 4) {
                    return
                }
                ajax.post(api.INVENTORYLOCATION, { keyword: value}).then(res => {
                    this.completeData = res.data
                })
            },
            confirmMove() {

                let updateArr = this.$refs.refMoveDetailTab.getRecordset().updateRecords
                if( updateArr.length > 0 ){
                    this.$customMessage.error('The modified data must be saved.')
                    return;
                }


                let params = {
                    logic: this.moveLogicVal,
                    remarks: this.remarksVal,
                    uid: this.moveHeaderUid,
                    updateInvDetailVos: [],
                    whsCode: this.moveWarehouse,
                    reasonCode: this.moveReasonVal,
                    topLocation: this.topLocation,
                    dataType: 'Move'
                }

                ajax.post(api.MOVECONFIRMINVENTORY, params).then(res => {
                    if (res.code == 200) {
                        this.headerStatus = '10'
                        this.$message.success(res.msg)
                    } else {
                        this.$customMessage.error(res.msg)
                    }
                })
            }
        }
    }
</script>